<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div slot="header">
            <strong>{{ card.title }}</strong>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <b-form-fieldset label="Nom">
                <b-form-input type="text" id="surname" v-model.trim="client.surname" autofocus></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-4">
              <b-form-fieldset label="Prénom">
                <b-form-input type="text" id="name" v-model.trim="client.name"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Fixe">
                <b-form-input type="text" id="tel_fixe" v-model.trim="client.landline"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Mobile">
                <b-form-input type="text" id="tel_mobile" v-model.trim="client.gsm"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
          </div><!--/.row-->
          <div class="row">
            <div class="col-sm-7">
              <b-form-fieldset label="Adresse">
                <b-form-input type="text" id="address" v-model.trim="client.street"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="CP">
                <b-form-input type="number" id="postal" v-model.trim="client.cp" placeholder="63000">{{ client.cp }}</b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-3">
              <b-form-fieldset label="Ville">
                <b-form-input type="text" id="town" v-model.trim="client.town"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
          </div><!--/.row-->
          <div class="row">
            <div class="col-sm-5">
              <b-form-fieldset label="e-mail">
                <b-form-input type="email" id="email" v-model.trim="client.email"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-7">
              <b-form-fieldset label="Commentaire">
                <b-form-input type="text" id="comment" v-model.trim="client.comment"></b-form-input>
              </b-form-fieldset>
            </div>
          </div>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="success" v-on:click="create" :disabled="! saveBtnEnabled"><i class="fa fa-edit-o"></i> Sauvegarder les modifications</b-button>
            <b-button type="reset" size="sm" variant="danger" v-on:click="close"><i class="fa fa-ban"></i> Fermer</b-button>
          </div>
        </b-card>
        <b-card header="Commandes">
          <ul>
            <li is="orders-row" v-for="order in customerOrders" v-bind:order="order.order" class="row"></li>
          </ul>
        </b-card>
      </div>
    </div><!--/.row-->
  </div><!-- whole page -->
</template>

<script>
import store from '@/store'
import router from '@/router'
// import Autocomplete from 'vue2-autocomplete-js'

var singleOrderRow = {
  template: '<tr><td>{{ item.ref }}</td><td>{{ item.name }} ({{ item.container }})</td><td>{{ item.quantity }} {{ item.unit_type }}</td></tr>',
  props: ['item']
}

var singleDateOrderRow = {
  components: {
    'order-detailled-row': singleOrderRow
  },
  template: '<li class="row"><p class="col-md-12">commande numéro {{ item.order_id }}&nbsp;&nbsp;&nbsp;({{item.operator}})</p>' +
  '<p class="col-md-12"><strong>commentaire: {{ item.comment }}</strong></p>' +
  '<div class="col-md-12">' +
  '<table class="table table-bordered table-striped table-sm" style="width=100%;">' +
  '<thead>' +
  '<tr>' +
  '<th style="width: 200px;">Ref</th>' +
  '<th>Intitulé</th>' +
  '<th style="width: 200px;">Qté</th>' +
  '</tr>' +
  '</thead>' +
  '<tbody>' +
  '<tr is="order-detailled-row" v-for="item in item.lines" v-bind:item="item"></tr>' +
  '</tbody>' +
  '</table>' +
  '</div>' +
  '</li>',
  props: ['item']
}

var ordersRow = {
  components: {
    'order-row': singleDateOrderRow
  },
  // template: '<tr><td>{{ order.date }}</td><td colspan="3"><table><tbody><tr is="order-detailled-row" v-for="item in order.items"></tr></tbody></table></td></tr>',
  template: '<li class="col-md-12"><p class="col-md-12">{{ order.date }}</p>' +
  '<ul class="col-md-12">' +
  '<li is="order-row" v-for="singleOrder in order.orders" v-bind:item="singleOrder" class="col-md-12" v-on:print="$emit(\'print\', singleOrder.order_id )">' +
  '</li></ul></li>',
  props: ['order']
}

export default {
  name: 'clientEdit',
  components: {
    'orders-row': ordersRow
  },
  data: function () {
    return {
      client: {
        id: 0,
        name: '',
        surname: '',
        email: '',
        gsm: '',
        landline: '',
        street: '',
        cp: undefined,
        town: ''
      },
      saveBtnEnabled: true,
      lastError: '',
      loadingSpinner: true,
      activeCustomerName: '',
      displayedCustomerName: '',
      customerOrderList: '',
      customerOrders: [],
      card: {
        title: 'Edition de Client'
      },
      outputConsoleLog: true
    }
  },
  beforeCreate () {
    if (!store.state.isLogged) {
      router.push('/')
    }
  },
  created () {
    // récupérer les données lorsque la vue est créée et
    // que les données sont déjà observées
    this.client.id = this.$route.params.id
    this.fetchCustomer()
    this.listOrders()
  },
  methods: {
    fetchCustomer () {
      this.$Progress.start()
      this.$http.get(process.env.API_URL + '/customer/get', {params: {'id': this.client.id}}).then((response) => {
        this.$Progress.finish()
        this.client = response.body
      },
      (error) => {
        console.log(error)
        this.$Progress.fail()
      })
    },
    create () {
      this.createBtnEnabled = false
      this.$Progress.start()
      this.$http.post(process.env.API_URL + '/customer/create', this.client).then((response) => {
        this.$Progress.finish()
        this.saveBtnEnabled = false
      },
      (error) => {
        // allow resubmit of data
        this.saveBtnEnabled = false
        this.$Progress.fail()
        console.log(error)
      })
    },
    close () {
      router.go(-1)
    },
    listOrders () {
      console.log('do list order for id ' + this.client.id)
      this.$Progress.start()
      this.$http.get(process.env.API_URL + '/orders/get-for-customer', {params: {'id': this.client.id}}).then((response) => {
        this.customerOrders = []
        var orderDate = response.body.list
        this.serverDate = response.body.date
        if (this.outputConsoleLog) {
          console.log('got ' + Object.keys(orderDate).length)
        }
        var orderCount = 0
        for (var d in orderDate) {
          if (this.outputConsoleLog) {
            console.log('date: ' + d)
          }
          var orders = []
          for (var i in orderDate[d]) {
            var currentOrder = orderDate[d][i]
            orders.push(currentOrder)
          }
          this.customerOrders.push({'order': {'date': d, 'orders': orders}})
          orderCount += orders.length
        }
        if (orderCount > 1) {
          this.commandesCount = orderCount + ' commandes'
        } else {
          this.commandesCount = orderCount + ' commande'
        }
        this.$Progress.finish()
      },
      (error) => {
        this.$Progress.fail()
        this.orders = []
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientEdit.vue?0523f496